module.exports = "/packs/icon-human-5e3a34a2b850ecdd695fc1a73818db44.png";